import { render } from "./ModalImagens.vue?vue&type=template&id=dc0dcc0e&scoped=true"
import script from "./ModalImagens.vue?vue&type=script&lang=js"
export * from "./ModalImagens.vue?vue&type=script&lang=js"

import "./ModalImagens.vue?vue&type=style&index=0&id=dc0dcc0e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\WS-CI002090\\workspace\\informativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc0dcc0e"]])

export default __exports__